import Css from "./style.module.scss";

import * as Icons from "@phosphor-icons/react";
import { getTextsData } from "selectors/texts";
import { useSelector } from "react-redux";
import DataStatuses from "const/DataStatuses";
import React, { useMemo } from "react";
import classNames from "classnames";
import useDocumentContext from "hooks/useDocumentContext";

const MessagesPanel = () => {
  const {
    documentData: { status, lastExportErrors }
  } = useDocumentContext();

  const { errors } = useSelector(getTextsData);

  const [message, IconComponent, style] = useMemo(() => {
    if ((status === DataStatuses.TO_REVIEW) && lastExportErrors?.length) {
      return [
        `${errors.exportDocumentError}: ${lastExportErrors.join("; ")}`,
        Icons.Warning,
        Css.error
      ];
    }

    return [];
  }, [status, lastExportErrors, errors]);

  return !!message && (
    <div className={classNames(Css.messagesPanel, style)}>
      <IconComponent weight="bold" className={Css.icon} />
      <span><b>{message}</b></span>
    </div>
  );
};

export default MessagesPanel;
